import * as constants from './constants';

const buildPriorityArray = () => {
  const ms = [];

  for (let i = 1;i <= 10;i++) {
    ms.push({ id: i, name: i });
  }

  return ms;
};

export const initialPartnerState = {
  loading: false,
  list: [], // массив со списком партнёров
  listByServiceId: undefined,
  loadedList: false,
  loadingList: false,
  item: {},
  statuses: [],
  types: [],
  priorities: buildPriorityArray(),
  error: undefined,
  partnerInsurance: [], // привязка партнёров к страховым компаниям (с какой страховой может работать данный партнёр ? )
  partnerInsurancePartnerId: undefined, // PartnerId - по какому партнёру хранятся данные в partnerInsurance
  logo: null,
  isFreeResponse: { isFree: true },
};

export const partnersReducer = (state = initialPartnerState, action) => {
  switch (action.type) {
    case constants.RESET_ERROR:
    case constants.FETCH_PARTNERS_SUCCESS:
    case constants.FETCH_PARTNERS:
    case constants.FETCH_PARTNERS_FAIL:
    case constants.FETCH_PARTNER_SUCCESS:
    case constants.FETCH_PARTNER_FAIL:
    case constants.CHECK_PARTNER_DOMAIN_SUCCESS:
    case constants.CHECK_PARTNER_DOMAIN_FAIL:
    case constants.CREATE_PARTNER_SUCCESS:
    case constants.CREATE_PARTNER_FAIL:
    case constants.UPDATE_PARTNER_SUCCESS:
    case constants.UPDATE_PARTNER_FAIL:
    case constants.DELETE_PARTNER_SUCCESS:
    case constants.DELETE_PARTNER_FAIL:
    case constants.FETCH_PARTNER_INSURANCE:
    case constants.FETCH_PARTNER_INSURANCE_SUCCESS:
    case constants.FETCH_PARTNER_INSURANCE_FAIL:
    case constants.CREATE_PARTNER_INSURANCE_SUCCESS:
    case constants.CREATE_PARTNER_INSURANCE_FAIL:
    case constants.DELETE_PARTNER_INSURANCE_SUCCESS:
    case constants.DELETE_PARTNER_INSURANCE_FAIL:
    case constants.CLEAR_PARTNER_INSURANCE:
    case constants.SET_LOGO_FAIL:
    case constants.SET_LOGO_SUCCESS:
    case constants.GET_LOGO_FAIL:
    case constants.GET_LOGO_SUCCESS:
    case constants.UPDATE_PARTNER_INSURANCE_FAIL:
    case constants.UPDATE_PARTNER_INSURANCE_SUCCESS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default {
  // Единственный оставшийся редьюсер partners-модуля: список/карточка партнёров,
  // страховые привязки, лого (базовый partnersReducer). Остальные подслайсы — на MobX:
  // contacts (partnerContactStore), legals (partnerLegalStore), fias (partnerFiasStore),
  // divisions (partnerDivisionStore), offices (partnerOfficeStore),
  // corporateExecutors (corporateExecutorStore).
  partners: partnersReducer,
};
